// extracted by mini-css-extract-plugin
module.exports = {"billMessage":"SelectPayment_billMessage__1xxYr"};